<template>
    <a class="item"
       :href="config.links[envMode].about[i18n.locale.value]"
       target="_blank"
    >
        {{ i18n.t("label_about")}}
    </a>
    <a class="item"
       v-if="currentRouteName === 'Home'"
       :href="config.links[envMode].userGuide[i18n.locale.value]"
       target="_blank"
    >
        {{ i18n.t("label_user_guide")}}
    </a>
    <a class="item"
       :href="config.links[envMode].contactUs[i18n.locale.value]"
       target="_blank"
    >
        {{ i18n.t("label_contact_us")}}
    </a>
    <a class="item"
       :href="config.links[envMode].copyright[i18n.locale.value]"
       target="_blank"
    >
        {{ i18n.t("label_copyright")}}
    </a>
    <a class="item"
       :href="config.links[envMode].faq[i18n.locale.value]"
       target="_blank"
    >
        {{ i18n.t("label_faq")}}
    </a>
    <a class="item"
       v-if="currentRouteName === 'Home'"
       :href="`${mpmsDomain}/${i18n.locale.value}/${config.links[envMode].activate}${accessToken}`"
       target="_blank"
    >
        {{ i18n.t("label_activate_more_ebooks")}}
    </a>
    <a class="item"
       :href="config.links[envMode].companyWebSite[i18n.locale.value]"
       target="_blank"
    >
        {{ i18n.t("label_company_website")}}
    </a>
</template>

<script>

    import {ref, inject} from "vue"
    import config from "@/config/config.json";
    import router from "@/router"

    export default {

        setup(props, context) {

            const i18n = inject('i18n');

            console.log("@Links.vue router:")
            console.log(router)

            const currentRouteName = ref( router.currentRoute.value.name)
            const accessToken = localStorage.accessToken

            return {
                envMode:process.env.VUE_APP_MODE,
                mpmsDomain:process.env.VUE_APP_MPMS_DOMAIN,
                currentRouteName,
                accessToken,
                i18n,
                config
            }
        }

    }
</script>

<style scoped lang="scss">

</style>